module.exports = __webpack_public_path__ + "img/company-templates.a4062fff.svg";